import React from 'react';
import {TextField, MenuItem,Grid, InputLabel, FormControl, FormHelperText,TextareaAutosize, Select,} from '@mui/material';
import './AddTalent.css'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function FormField({ label, type, value, placeholder, options, containerClass, name, onChange, onBlur, error, labelClass , multiple = false, }) {
    return (
      <div className={containerClass || ''}>
      {type === "text" && (
          <TextField
            className="textfield"
            label={label}
            value={value}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            error={!!error}
            helperText={error}
          />
        )}
  
        {type === "select" && (
          <FormControl     className={`select-control ${(name?.startsWith('langue_') || name?.startsWith('niveauLangue_')) ? 'select-small' : ''}`}
          error={!!error}>
            <InputLabel>{label}</InputLabel>
            <Select
              multiple={multiple}
              value={
                multiple
                  ? Array.isArray(value) ? value : []
                  : typeof value === "string" ? value : ""
              }
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              label={label}
            >
              {!multiple && (
                <MenuItem value="" disabled>
                  -- Sélectionner --
                </MenuItem>
              )}
              {options.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        )}
  
        {type === "textarea" && (
          <FormControl fullWidth error={!!error}>
            <InputLabel shrink>{label}</InputLabel>
            <TextareaAutosize
              minRows={1}
              value={value}
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              className="textarea"
            />
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        )}
     {type === "phone" && (
      <FormControl fullWidth error={!!error}>
        <InputLabel shrink>{label}</InputLabel>
        <PhoneInput
          country={'fr'} 
          onlyCountries={['fr', 'ma', 'tn']}
          value={value}
          onChange={(phone, countryData, e, formattedValue) => 
            onChange({ target: { name, value: `+${phone}` } })
          }
          inputProps={{
            name: name,
            onBlur: onBlur,
            placeholder: placeholder || 'Entrez le numéro de téléphone',
          }}
          containerClass="phone-input-container"
          inputClass="phone-input"
          buttonClass="phone-input-flag"
          className="textfield"
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    )}


        {type === "file" && (
          <FormControl fullWidth error={!!error}>
            <InputLabel shrink>{label}</InputLabel>
            <label htmlFor={name}>
              <div className="file-upload-label">
                Télécharger
              </div>
            </label>
            <input
              id={name}
              type="file"
              name={name}
              onChange={onChange}
              style={{ display: 'none' }}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        )}
      </div>
    );
  }

  export default FormField;
